<div class="cov-sold-to-information py-1 px-3 d-flex">
  <div class="d-flex flex-column">
    <span class="cov-fs-muted">{{ 'soldToInformation.title' | transloco }}</span>
    @if (shownSoldTo()) {
      <span
        title="{{shownSoldTo()?.displayValue}}"
        class="cov-sold-to-information-address"
        >{{ shownSoldTo()?.displayValue }}</span
      >
    } @else {
      <div class="d-flex">
        <span
          class="d-block d-md-none d-xl-block me-2"
          >{{ 'soldToInformation.multipleSoldTos' | transloco }}</span
        >
        <cov-icon [iconName]="IconName.INFO"></cov-icon>
      </div>
    }
  </div>
</div>
